import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "@/i18n";

const A = "https://customer-assets-39nsmqrw.emergentagent.net/job_aa7dc63b-d9fa-4ce1-9d9b-b30905f02928/artifacts";
const B = "https://customer-assets-lxgj4vgw.emergentagent.net/job_sinar-mubarokah/artifacts";

const slides = [
  { img: `${B}/uouy6kx7_kaso%20ikatan%20bekisting%20super.jpeg`, id: "Kayu Proyek Ikatan 4x6x4", en: "Bundled Project Timber 4x6x4" },
  { img: `${A}/ep5gdt76_balok%208x12x4%20-%20Salin.jpeg`, id: "Balok 6x12x4", en: "Beams 6x12x4" },
  { img: `${A}/b7gl9f2c_kaso%204x6%20batangan.jpeg`, id: "Kaso 5x7x4", en: "Kaso 5x7x4" },
];

const ORDER = [0, 1, 2, 1];

export default function WoodSlideshow() {
  const { lang, t } = useLanguage();
  const [step, setStep] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setStep((s) => (s + 1) % ORDER.length), 2600);
    return () => clearInterval(timer);
  }, []);

  const idx = ORDER[step];
  const slide = slides[idx];

  return (
    <div className="mt-20" data-testid="wood-slideshow">
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-sky-400 font-semibold text-center">
        {lang === "id" ? "BANYAK PILIHAN · SELALU READY" : "MANY OPTIONS · ALWAYS IN STOCK"}
      </p>
      <h2 className="mt-3 font-display font-extrabold tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl text-center" data-testid="slideshow-title">
        {t.productPage.slideshowTitle}
      </h2>

      <div className="mt-8 relative clip-industrial overflow-hidden border-4 border-slate-700/60 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.6)] aspect-[4/3] sm:aspect-[16/7] bg-[#070E1A]">
        <AnimatePresence mode="popLayout">
          <motion.div
            key={`${idx}-${step}`}
            initial={{ opacity: 0, x: step % 2 === 0 ? 80 : -80, scale: 1.04 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: step % 2 === 0 ? -80 : 80, scale: 1.02 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="absolute inset-0"
          >
            <img
              src={slide.img}
              alt={slide.id}
              className="w-full h-full object-cover"
              data-testid={`slideshow-img-${idx}`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-900/25 to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-6 sm:p-10">
              <motion.p
                initial={{ y: 24, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.25, duration: 0.6 }}
                className="font-display font-extrabold text-white text-xl sm:text-3xl lg:text-4xl tracking-tight drop-shadow-lg"
                data-testid="slideshow-label"
              >
                {lang === "id" ? slide.id : slide.en}
              </motion.p>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="absolute top-4 right-4 flex gap-2" data-testid="slideshow-dots">
          {slides.map((_, i) => (
            <span
              key={i}
              className={`h-1.5 rounded-full transition-all duration-500 ${idx === i ? "w-7 bg-sky-400" : "w-3 bg-white/50"}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
